import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { BetslipPick } from '../../../../../../../core/picks/betslip-pick';
import { isBetBuilderPick } from '../../../../../../../core/utils';
import { BetBuilderPick } from '../../../../../../linear-bet-builder/models';
import { BetslipMarketSubTypeLogoService } from '../../../../../../picks/services/betslip-market-sub-type-logo.service';
import { BetBuilderSelectionModel } from '../../../../../../single-bet/components/betbuilder-selection.model';

@Component({
    selector: 'bs-linear-combo-bet-builder-details',
    templateUrl: './linear-combo-bet-builder-details.component.html',
    styleUrls: ['./linear-combo-bet-builder-details.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export default class LinearComboBetBuilderDetailsComponent {
    @Input() picks: BetslipPick[];

    constructor(private betslipMarketSubTypeLogoService: BetslipMarketSubTypeLogoService) {}

    isBetBuilderPick(pick: BetslipPick): pick is BetBuilderPick {
        return isBetBuilderPick(pick);
    }

    getPickSelection(pick: BetslipPick): BetBuilderSelectionModel {
        return {
            longId: pick.id.toString(),
            name: pick.optionName.name,
            details: pick.marketName.name,
            marketSubTypeSignpostingText: this.betslipMarketSubTypeLogoService.getMarketSubTypeSignpostingText(pick),
        };
    }
}
